// extracted by mini-css-extract-plugin
export var audioPlayer = "_ls-0";